import { atom } from 'jotai';

type InfoSessionCancelledProps = {
  date: Date;
  sessionID: string;
  enduserID: string;
  fullName: string;
};

export const informationInviteAtom = atom({
  patientName: '',
  inviteLink: '',
  sessionCreated: '',
});

export const infoSessionCancelledAtom = atom<InfoSessionCancelledProps | null>(
  null,
);

export const drawerInviteAtom = atom<
  'invite-created' | 'invite-schedule' | 'invitation-history' | undefined
>(undefined);
